class FeatureFlag {
    #featureFlagVal;

    constructor(featureFlagVal) {
        this.#featureFlagVal = featureFlagVal;
    }

    isTrue() {
        return 'true' === this.#featureFlagVal?.toString()?.toLowerCase();
    }

    isFalse() {
        return 'false' === this.#featureFlagVal?.toString()?.toLowerCase();
    }

    isEntitlements() {
        return 'entitlements' === this.#featureFlagVal?.toString()?.toLowerCase();
    }

    hasValue() {
        return this.#featureFlagVal !== undefined && this.#featureFlagVal !== null;
    }

    getFeatureFlagVal() {
        return this.#featureFlagVal;
    }
}

export default FeatureFlag;
